<template>
    <div class="row">
        <div class="col-12">
            <div class="pull-right mb-1 mt-1 mr-2" v-if="!showOnly">
                <button
                    @click="editable = !editable"
                    class="btn btn-brand"
                >
                    {{ uLang('app.edit_credit') }}
                    <i class="fa" :class="editable ? 'fa-unlock' : 'fa-lock'"/>
                </button>
            </div>

            <rea-loader :loading="loading"/>

            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>{{ uLang('app.trajectory_type') }}</th>
                        <th>{{ uLang('app.credit') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="credit in coachTrajectoryCredit">
                        <td>
                            {{ credit.trajectory_type }}
                        </td>
                        <td v-if="editable">
                            <input
                                v-model.number="credit.credit"
                                @change="storeCredit"
                                type="number"
                                min="0"
                                max="100"
                            >
                        </td>
                        <td v-else>
                            {{ credit.credit }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import { ReaLoader } from '~/components/helpers'
    import { debounce } from 'lodash'

    export default {
        name: "coach-credit-tab",
        components: {
            'rea-loader': ReaLoader,
        },
        props: {
            resource: {
                default: null
            },
            resourceId: {
                required: true,
            },
            showOnly: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loading: true,
                editable: false,
                coachTrajectoryCredit: [],
            }
        },
        created() {
            this.retrieveCoachCredit();
        },
        methods: {
            async retrieveCoachCredit() {
                this.loading = true;

                const { data } = await window.axios.get(route('coach_credit.show', { relation: this.resourceId }));
                this.coachTrajectoryCredit = data;

                this.loading = false;
            },
            storeCredit: debounce(async function () {
                if (this.showOnly) {
                    return
                }

                await window.axios.post(
                    route('coach_credit.store', {relation: this.resourceId}), {
                        credit: this.coachTrajectoryCredit
                    }
                ).then(() => {
                    this.$snotify.success(uLang('app.store_coach_credit_success'));
                }).catch(() => {
                    this.$snotify.error(uLang('app.store_coach_credit_error'));
                })
            }, 500)
        }
    }
</script>
